import React, { SyntheticEvent} from 'react';
import { PlateSizeHeading, PlateSizeTitle, PlateSizeSubtitle, MessageLocationWrapper } from './PlateDesignDetails.styles';
import { DropdownProps, Popup } from 'semantic-ui-react';
import { KpFormDropdown } from '@styles/Global.forms';
import theme from '@styles/theme';
type PlateDropdownOptionProps = {
    title: string;
    subtitle?: string;
    subtitlePopup?: any
    options: Array<{
        key: string;
        value: number | string;
        text: string;
    }>;
    selectedValue: number | string;
    handleChange: (event: SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => void;
    darkTheme: boolean
};
export const PlateDropdownOptions = ({ title, subtitle, subtitlePopup, options, selectedValue, handleChange, darkTheme }: PlateDropdownOptionProps) => {
    const isDisabled = options.length === 1;
    return (<MessageLocationWrapper>
        <PlateSizeHeading>
            <PlateSizeTitle darkTheme={darkTheme}>{title}</PlateSizeTitle>
            {
                subtitle && !subtitlePopup &&
                <PlateSizeSubtitle>{subtitle}</PlateSizeSubtitle>
            }
            {
                subtitle && subtitlePopup &&
                <Popup basic position='right center' trigger={<PlateSizeSubtitle darkTheme={darkTheme}>Size Guide</PlateSizeSubtitle>}>
                    <Popup.Content>
                        {subtitlePopup}
                    </Popup.Content>
                </Popup>
            }
        </PlateSizeHeading>
        <KpFormDropdown backgroundColor={theme.brand.colors.white} icon='chevron down' fluid selection disabled={isDisabled} options={options} value={selectedValue} onChange={handleChange} />
    </MessageLocationWrapper>);
};
